var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 7.49984V1.6665L8.83325 3.33317",
    stroke: "#C56616",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.6665L12.1667 3.33317",
    stroke: "#C56616",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1499 10.8335H5.8249C6.14157 10.8335 6.4249 11.0085 6.56657 11.2918L7.54157 13.2418C7.8249 13.8085 8.3999 14.1668 9.03324 14.1668H11.9749C12.6082 14.1668 13.1832 13.8085 13.4666 13.2418L14.4416 11.2918C14.5832 11.0085 14.8749 10.8335 15.1832 10.8335H18.8166",
    stroke: "#C56616",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33341 4.2749C3.38341 4.70824 2.16675 6.44157 2.16675 9.9999V12.4999C2.16675 16.6666 3.83341 18.3332 8.00008 18.3332H13.0001C17.1667 18.3332 18.8334 16.6666 18.8334 12.4999V9.9999C18.8334 6.44157 17.6167 4.70824 14.6667 4.2749",
    stroke: "#C56616",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadList);
export default __webpack_public_path__ + "static/media/upload-list.ba6bfe00f480a39d4d40819c950d5599.svg";
export { ForwardRef as ReactComponent };